import { Injectable } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';

import {
  mobile,
  tablet,
  desktop,
} from 'app/utils';

@Injectable()
export class MediaQueryService {

  isMobile: MediaQueryList;
  isTablet: MediaQueryList;
  isDesktop: MediaQueryList;

  constructor(
    private _media: MediaMatcher,
  ) {
    this.isMobile = _media.matchMedia(mobile);
    this.isTablet = _media.matchMedia(tablet);
    this.isDesktop = _media.matchMedia(desktop);
  }
}
